"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAMLIdentifierFormat = exports.EUserObjectMatching = exports.EApplySSOPermissions = exports.EAuthSaml2SigantureAlgorithm = exports.EAuthSaml2Signing = exports.EAuthLogLevel = exports.EAuthStrategy = void 0;
var EAuthStrategy;
(function (EAuthStrategy) {
    EAuthStrategy["TE_IDP"] = "TE_IDP";
    EAuthStrategy["SAML2"] = "SAML2";
    EAuthStrategy["CAS"] = "CAS";
})(EAuthStrategy = exports.EAuthStrategy || (exports.EAuthStrategy = {}));
var EAuthLogLevel;
(function (EAuthLogLevel) {
    EAuthLogLevel["NONE"] = "NONE";
    EAuthLogLevel["LOW"] = "LOW";
    EAuthLogLevel["HIGH"] = "HIGH";
    EAuthLogLevel["DEBUG"] = "DEBUG";
})(EAuthLogLevel = exports.EAuthLogLevel || (exports.EAuthLogLevel = {}));
var EAuthSaml2Signing;
(function (EAuthSaml2Signing) {
    EAuthSaml2Signing["NONE"] = "NONE";
    EAuthSaml2Signing["SIGN"] = "SIGN";
    EAuthSaml2Signing["REQUIRED"] = "REQUIRED";
})(EAuthSaml2Signing = exports.EAuthSaml2Signing || (exports.EAuthSaml2Signing = {}));
var EAuthSaml2SigantureAlgorithm;
(function (EAuthSaml2SigantureAlgorithm) {
    EAuthSaml2SigantureAlgorithm["SHA1"] = "sha1";
    EAuthSaml2SigantureAlgorithm["SHA256"] = "sha256";
    EAuthSaml2SigantureAlgorithm["SHA512"] = "sha512";
})(EAuthSaml2SigantureAlgorithm = exports.EAuthSaml2SigantureAlgorithm || (exports.EAuthSaml2SigantureAlgorithm = {}));
var EApplySSOPermissions;
(function (EApplySSOPermissions) {
    EApplySSOPermissions["ALWAYS"] = "ALWAYS";
    EApplySSOPermissions["NEW_USERS"] = "NEW_USERS";
    EApplySSOPermissions["NEVER"] = "NEVER";
})(EApplySSOPermissions = exports.EApplySSOPermissions || (exports.EApplySSOPermissions = {}));
var EUserObjectMatching;
(function (EUserObjectMatching) {
    EUserObjectMatching["OBJECT_EXTID"] = "OBJECT_EXTID";
    EUserObjectMatching["OBJECT_FIELD"] = "OBJECT_FIELD";
})(EUserObjectMatching = exports.EUserObjectMatching || (exports.EUserObjectMatching = {}));
exports.SAMLIdentifierFormat = {
    Unspecified: 'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
    Email: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
    Persistent: 'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
    Transient: 'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
};
